import React from 'react';

import Section from '../../layout/Section';
import Accordion, { AccordionCard } from '../../molecules/Accordion';
import SquareGenerator from '../../molecules/SquareGenerator';

import {
    SHeader,
    SAccordionContainer,
    SCardContent,
} from './styles';

const SectionAccordion = ({
    config,
    background = false,
}) => {
    const {
        title,
        id,
        content,
        squares,
        forwardedRef,
    } = config;

    return (
        <Section
            background={ background }
            forwardedRef={ forwardedRef }
            id={ id }
        >
            <SHeader>
                { title }
            </SHeader>
            <SAccordionContainer>
                <Accordion concurrent>
                    {
                        content.map(({
                            id,
                            title,
                            text,
                            isExpanded = false,
                        }) => (
                            <AccordionCard
                                header={ title }
                                expanded={ isExpanded }
                                key={ id }
                                id={ id }
                            >
                                <SCardContent>
                                    { text }
                                </SCardContent>
                            </AccordionCard>
                        ))
                    }
                </Accordion>
            </SAccordionContainer>
            {
                !!squares && <SquareGenerator squares={ squares }/>
            }
        </Section>
    );
};

export default SectionAccordion;
